module.exports = __webpack_public_path__ + "static/media/2.17.61891f81.png";